
import { styled } from "@mui/material/styles";
import { ListItem } from "@mui/material";
import { infoStyle } from "../../../../assets/jss/material/infoarea/infoStyle";

interface IInfoAreaProps {
  icon: any;
  title: string;
  description?: string;
  iconColor?: "primary" | "warning" | "danger" | "success" | "info" | "rose" | "gray";
  listDescription?: string[];
} 

export function InfoArea(props: IInfoAreaProps) {
  const { title, description, iconColor } = props;
  const InfoAreaStyle = styled('div')(infoStyle.infoArea);
  const IconWrapperStyle = styled('div')(infoStyle.iconWrapper + " " + infoStyle[iconColor || "gray"]);
  const DescriptionStyle = styled('div')(infoStyle.descriptionWrapper);
  const TitleStyle = styled('h4')(infoStyle.title);
  const ParagraphyStyle = styled('p')(infoStyle.description);
  const ListStyle = styled('ul')(infoStyle.list);


  return (
    <InfoAreaStyle>
      <IconWrapperStyle>
        <props.icon  style={{ width: "36px" ,height: "36px", color: "#e91e63"}}/>
      </IconWrapperStyle>
      <DescriptionStyle>
        <TitleStyle>{title}</TitleStyle>
        {description ? <ParagraphyStyle>{description}</ParagraphyStyle> : null}
        {props.listDescription ? (
          <ListStyle>
            {props.listDescription.map((item, key) => (
              <ListItem key={key}>
                {item}
              </ListItem>
            ))}
          </ListStyle>
        ) : null}
      </DescriptionStyle>
    </InfoAreaStyle>
  );
}

